import React, {Component} from 'react'
import {Checkbox} from 'components/styled/Checkbox'
import FormContext from 'components/FormContext'
import styles from './styles'
import {MemberTitle, ReadOnly} from 'components'
import {Markdown} from 'components'

export class Disclaimer extends Component {
  static defaultProps = {
    name: 'account.steps.disclaimer',
  }

  render = () => {
    return (
      <ReadOnly on={this.props.review || this.props.context.limitedUpdate}>
        <FormContext
          context={this.props.context}
          onChange={this.props.onChange}
          errorContext={this.props.errorContext}
          metaRef={this.props.metaRef}
        >
          <div className={styles.section} style={{color: '#1B3044'}}>
            <Markdown mdtext={this.props.context.disclaimer} />
          </div>
          <div className={styles.section}>
            <MemberTitle variant='body1' member='disclaimerAcceptedAt'>
              <Checkbox
                style={{marginLeft: -12}}
                member="disclaimerAcceptedAt"
                checkedAsTime
                required
                meta={{requiredError: 'You must accept the risk disclosure to register your account',
                       errorLabel: `${process.env.REACT_APP_NAME} Disclaimer`}}
              /> I have read and understood the {process.env.REACT_APP_NAME} risk disclosure
            </MemberTitle>
          </div>
        </FormContext>
      </ReadOnly>
    )
  }
}